import { message, notification } from 'antd';

/**
 * Show a success notification
 * @param title Title of the notification
 * @param description Description of the notification
 */
export const showSuccessNotification = (title: string, description?: string) => {
  notification.success({
    message: title,
    description,
    duration: 4,
  });
};

/**
 * Show an error notification
 * @param title Title of the notification
 * @param description Description of the notification
 */
export const showErrorNotification = (title: string, description?: string) => {
  notification.error({
    message: title,
    description,
    duration: 6,
  });
};

/**
 * Show a warning notification
 * @param title Title of the notification
 * @param description Description of the notification
 */
export const showWarningNotification = (title: string, description?: string) => {
  notification.warning({
    message: title,
    description,
    duration: 5,
  });
};

/**
 * Show an info notification
 * @param title Title of the notification
 * @param description Description of the notification
 */
export const showInfoNotification = (title: string, description?: string) => {
  notification.info({
    message: title,
    description,
    duration: 4,
  });
};

/**
 * Show a success message
 * @param content Content of the message
 */
export const showSuccessMessage = (content: string) => {
  message.success(content);
};

/**
 * Show an error message
 * @param content Content of the message
 */
export const showErrorMessage = (content: string) => {
  message.error(content);
};

/**
 * Show a warning message
 * @param content Content of the message
 */
export const showWarningMessage = (content: string) => {
  message.warning(content);
};

/**
 * Show an info message
 * @param content Content of the message
 */
export const showInfoMessage = (content: string) => {
  message.info(content);
};
